export default {
  title: 'Importação de ',
  history: 'Histórico',
  date: 'Data',
  doneBy: 'Feito por',
  status: 'Status',
  errorReport: 'Relatório de erros',
  importing: 'Importando',
  error: 'Erro',
  completed: 'Concluída',
  importHistory: 'Histórico de Importação',
  of: 'de',
  fileNotSupported: 'Arquivo não suportado. Somente arquivos xlsx são permitidos',
  dragExcelHere: 'Arraste o excel aqui ou clique para selecionar',
  importError: 'Ocorreu um erro na importação!',
  whatToDoNow: 'O que fazer agora?',
  downloadIncorrectData: 'Baixar a planilha com os dados incorretos',
  fixDataInNewSheet: 'Corrigir os dados na nova planilha',
  doNewUpload: 'Fazer um novo upload',
  downloadNewSheet: 'Download da nova planilha',
  importCompletedSuccessfully: 'Importação concluída com sucesso!',
  importInstructions: 'Instruções de importação',
  importInstructionsDescription:
    'As importações da Btime são feitas através de modelo de planilhas pré definidas. Para uma importação de dados ser aceita pelo nosso sistema, faça o download da planilha modelo abaixo e importe uma com a mesma estrutura.',
  downloadTemplate: 'Download do modelo',
  notDownloadedWarning:
    'Você ainda não baixou a planilha com os dados incorretos. Certeza que não quer fazer isso antes?'
}
